import type { MouseEvent } from 'react';
import styled from 'styled-components';

import { BasicParagraph } from '@genially/design-system';

interface WrapperProps {
  $hasText?: boolean;
  $expandRight?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: MouseEvent<HTMLDivElement>) => void;
}

export const Wrapper = styled.div<WrapperProps>(
  ({
    theme: { color, size, transition },
    $hasText,
    $expandRight,
    onClick,
    onMouseEnter,
    onMouseLeave,
  }) => ({
    padding: $expandRight
      ? `${size.units(1.5)} ${size.units($hasText ? 2 : 1.5)}`
      : $hasText
        ? `${size.units(1.5)} ${size.units(2)}`
        : 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: $expandRight ? 'flex-start' : 'center',
    gap: size.units(1),
    minWidth: size.units(5),
    height: size.units(5),
    backgroundColor: color.background.reversed.default(0.5),
    borderRadius: size.units(5),
    cursor: onClick || onMouseEnter || onMouseLeave ? 'pointer' : 'default',
    transition: transition.standard(),
    pointerEvents: 'auto',

    ...(onClick && {
      '&:hover': {
        transform: `scale(0.95)`,
      },
    }),
  }),
);

export const StyledBasicParagraph = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const StyledIcon = styled.span(({ theme: { color, size } }) => ({
  width: size.units(2),
  height: size.units(2),
  minWidth: size.units(2),
  minHeight: size.units(2),
  color: color.content.reversed.default(),
}));
